import React from 'react'
import Show from './Show'
import { Card } from 'react-bootstrap'
import Schedule from './Schedule'

export default class ComingUp extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    return (
      <Card className='mb-3'>
        <Card.Body className='text-start'>
          <Card.Title className='text-end'>Coming Up</Card.Title>
          <hr />
          <Show next={true} />
          <hr style={{ width: '75%', margin: '10px auto', marginRight: '0px' }} />
          <Schedule />
        </Card.Body>
      </Card>
    )
  }
}
